var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeup = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.502 9.207 8.709 12a.5.5 0 0 1-.707-.707l3.646-3.647a.5.5 0 0 1 .708 0l3.646 3.647a.5.5 0 1 1-.707.707l-2.793-2.793V16.5a.5.5 0 1 1-1 0V9.207Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.002 2c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm-9 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z",
  fill: "currentColor"
})));
export { SvgTypeup as ReactComponent };
export default __webpack_public_path__ + "33fe1023cd18d06ed027c1f0890186f3.svg";